import { State, OptionsActionTypes } from './types';
import { OptionAction } from './actions';

const initialState: State = {
  displaySearch: true,
  displayAddButton: true,
  displayMenu: true,
  searchTerm: "",
};

const optionsReducer = (state: State = initialState, action: OptionAction): State => {
  switch (action.type) {
    case OptionsActionTypes.SET_DISPLAY_ADD_BUTTON:
      return {
        ...state,
        displayAddButton: action.payload.display
      };

    case OptionsActionTypes.SET_DISPLAY_SEARCH:
      return {
        ...state,
        displaySearch: action.payload.display
      };

    case OptionsActionTypes.SET_DISPLAY_MENU:
      return {
        ...state,
        displayMenu: action.payload.display
      };

    case OptionsActionTypes.SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload.term
      };

    default:
      return state;
  }
};

export default optionsReducer;
